import React, { useState } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import ChicosFinal from "../../assets/img/ChicosFinal.svg"; // Asegúrate de que la ruta sea correcta
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import AccountService from "../../services/AccountService";
import { LoggedUser } from "../../types/usuarios/LoggedUser";
import { useDispatch } from "react-redux";
import { inUser } from "../../redux/slices/auth.slice";
import { useLogin } from "../../utils/sessionLogin";



export const HomePage: React.FC<{}> = () => {

    const isAuthenticated = useIsAuthenticated();
    
    const {setLogin} = useLogin();

    const handleLogin = async () => {
        setLogin();
    }

    return (
        <Container maxWidth="md" sx={{ padding: "20px", textAlign: "center" }}>
            {/* Título Principal */}
            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ color: "#243165", fontWeight: "bold", fontSize: "24px" }}
            >
                Sistema de gestión de ayudantías
            </Typography>

            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", fontSize: "16px" }}
            >
                ¡Bienvenidos!
            </Typography>

            {/* Botón de Iniciar Sesión */}
            {!isAuthenticated && (
                <Box sx={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        // onClick={() => GoTo("/Login")}
                        onClick={handleLogin}
                        sx={{
                            backgroundColor: "#243165",
                            color: "#FFFFFF !important",
                            "&:hover": { backgroundColor: "#1e284c" },
                            minWidth: "180px",
                            boxShadow: 3,
                            mt: 1,
                        }}
                    >
                        Iniciar Sesión
                    </Button>
                </Box>
            )}

            {/* Imagen debajo del texto */}
            <Box sx={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
                <img
                    src={ChicosFinal}
                    alt="Chicos final"
                    style={{ maxWidth: "50%", height: "auto" }}
                />
            </Box>
        </Container>
    );
};
